define(['angular'], function(angular) {


    function EulerProvider() {
        let bdcUrl;

        /**
         * @param {String} url
         */
        this.setBDCUrl = function setBDCUrl(url) {
            bdcUrl = url;
        };

        this.$get = [
            '$http',
            function($http) {
                let self = {};

                self.getBdcUrl = function() {
                    return bdcUrl;
                };
                /**
                 * Get a token
                 * @return {Promise}
                 */
                self.getToken = function() {
                    return $http.post(bdcUrl + 'euler/oauth').then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * get risk for a store
                 * @param data
                 * @return {Promise}
                 */
                self.getRisk = function(data) {
                    return $http.post(bdcUrl + 'euler/risk', data).then(function(res) {
                        return res.data;
                    });
                };

                return self;
            }
        ];
    }

    angular.module('app.bdc.common.eulerProvider', []).provider('euler', EulerProvider);
});
